import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function EditNotesForm({ oldNote, oldUpdatedBy, handleNotesUpdate, id, user }) {
    const [note, setNote] = useState(oldNote);
    const [updatedBy, setUpdatedBy] = useState(oldUpdatedBy);

    const [error, setError] = useState("");
  
    return (
      <Form>
        <Form.Group controlId="formEmail">
            <Form.Label>Notes</Form.Label>
            <Form.Control name="note" type="text" placeholder={note} onChange={e => setNote(e.target.value)} value={note} />
        </Form.Group>
        <Form.Group controlId="formEmail">
            <Form.Label>Updated By</Form.Label>
            <Form.Control name="updatedBy" type="text" placeholder={updatedBy} onChange={e => setNote(e.target.value)} value={user} disabled/>
        </Form.Group>
        <Button style={{width: '100%', marginTop: '10px'}} onClick={() => handleNotesUpdate(note, id)} className="formButton" type="submit">
            Submit
        </Button>
        {error && (
            <div className="errors">
                <p className="text-danger">{error}</p>
            </div>
        )}
      </Form>
    );
  }

  export default EditNotesForm;
